Object.defineProperty(exports, "__esModule", {
  value: true
});
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports['default'] = CAN_USE_DOM;


//////////////////
// WEBPACK FOOTER
// ./~/consolidated-events/lib/canUseDOM.js
// module id = 87
// module chunks = 0